module.exports = __webpack_public_path__ + "sx.2ce155b8843c542882f1.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/sx.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/sx.svg
// module chunks = styles